module.exports = __webpack_public_path__ + "img/Published.60089ec5.png";